import { makeRandomAlphaNumeric } from 'zoomforth_zfutils/random.js';

const SUBPAGE_ID_CHAR_COUNT = 5;

export const generateSubpageId = () =>
  makeRandomAlphaNumeric(SUBPAGE_ID_CHAR_COUNT);

export const getSubpageSlug = (subpage) =>
  subpage && (subpage.slug || subpage.id);

export const makeNewSubpageData = ({ id=null })=>
  ({
    id,
    slug: id,
    type: 'multisection',
    orderedSectionIds: [],
    isHidden: false,
    isScrollToTopEnabled: true
  });
